import {
  DEFAULT_OGC_WMS_DPI,
  ILatitudeAndZoom,
  INCHES_PER_METER,
  METERS_PER_INCH,
  METERS_PER_PX_AT_EQUATOR
} from "form/map/model"
import { Map } from "mapbox-gl"
import { getLatitudeInRadian } from "./common"
import { getResolution, getScreenResolutionInMeters } from "./resolution"

export function getScaleDenominatorFromResolution(params: ILatitudeAndZoom): number {
  return DEFAULT_OGC_WMS_DPI * INCHES_PER_METER * getResolution(params)
}

export function getScaleFromResolution(params: ILatitudeAndZoom): string {
  return `1 : ${getScaleDenominatorFromResolution(params)}`
}

export function getScaleFromMetersPerPixel(params: ILatitudeAndZoom): string {
  return `1 : ${getScaleDenominatorFromMetersPerPixel(params)}`
}

export function getScaleDenominatorFromMetersPerPixel(params: ILatitudeAndZoom): number {
  return getMetersPerPixel(params) / getScreenResolutionInMeters()
}

export function getMetersPerPixel(params: ILatitudeAndZoom): number {
  return (
    (40075016.686 * Math.cos(getLatitudeInRadian(params.map, params?.latitude))) /
    (512 * Math.pow(2, typeof params?.zoom === "number" ? params?.zoom : params.map.getZoom()))
  )
}

export function getZoomFromScale(map: Map, scaleDenominator: number, latitude?: number): number {
  if (typeof scaleDenominator !== "number") {
    throw Error("scaleDenominator is not a number")
  }
  if (scaleDenominator <= 0) {
    throw Error("The scale denominator must be greater than zero")
  }
  return Math.log2(
    (METERS_PER_PX_AT_EQUATOR *
      Math.cos(getLatitudeInRadian(map, latitude)) *
      (1 / scaleDenominator) *
      DEFAULT_OGC_WMS_DPI) /
      METERS_PER_INCH
  )
}
